import { ValuesType } from 'utility-types'

import { BillingCurrency } from 'common/billing/constants/BillingCurrency'
import { PricePeriod } from 'common/billing/constants/PricePeriod'
import { ProductSlug } from 'common/billing/constants/ProductSlug'
import { AddOnWithPrice, ExtendPrice, WithAbilities } from 'common/billing/entities/pro/interfaces'
import { ProductType } from 'common/core/interfaces/products'
import {
  AddOn,
  AddOnSchema,
  AutomationPlan,
  InboxPlan,
  InboxPlanSchema,
  Products,
} from 'shared/api/requests/billing/schemas'
import { makeGuardFromSchema } from 'shared/api/requests/utils'

import { AbilitiesMap } from '../constants/AbilitiesMap'

// Hack
export const getCurrency = () =>
  window.__INIT__['app.currentAccount']?.billing_info?.currency ?? BillingCurrency.USD

const isAddOn = makeGuardFromSchema(AddOnSchema)
const isInbox = makeGuardFromSchema(InboxPlanSchema)

export function convertPrice(addOn: AddOn): WithAbilities<AddOnWithPrice>
export function convertPrice(
  inbox: InboxPlan,
): WithAbilities<ExtendPrice<InboxPlan>> & { slug: ProductSlug.INBOX }
export function convertPrice(
  automation: AutomationPlan,
): WithAbilities<ExtendPrice<AutomationPlan>> & { slug: ProductSlug.AUTOMATION }
export function convertPrice<ProductType extends ValuesType<Products>>(
  product: ProductType,
): ExtendPrice<ProductType>
export function convertPrice(product: InboxPlan | AutomationPlan | AddOn) {
  if (isAddOn(product)) {
    return {
      ...product,
      abilities: AbilitiesMap.addOns[product.slug],
      price: {
        amount: product.price,
        currency: getCurrency(),
        period: PricePeriod.MONTHLY,
      },
    }
  }

  if (isInbox(product)) {
    return {
      ...product,
      abilities: AbilitiesMap.plans[ProductType.INBOX],
      slug: ProductSlug.INBOX,
      price: {
        amount: product.price,
        currency: getCurrency(),
        period: PricePeriod.MONTHLY,
      },
    }
  }

  return {
    ...product,
    abilities: AbilitiesMap.plans[ProductType.AUTOMATION],
    slug: ProductSlug.AUTOMATION,
    price: {
      amount: product.price,
      currency: getCurrency(),
      period: PricePeriod.MONTHLY,
    },
  }
}
